<template>
  <div class="pb-2">
    <b-row class="px-2 align-items-center section-header-row no-gutters">
      <b-col><h3>Office</h3></b-col>
      <b-col cols="2" class="text-right">
        <b-button
          v-b-modal.officeEdit
          class="main-navigation-button edit_button"
          variant="white"
          btn-color="primary1"
        >
          <v-avatar size="25">
            <img src="img/Edit.png" />
          </v-avatar>
        </b-button>
      </b-col>
    </b-row>
      <b-modal
        id="officeEdit"
        title="Office Information"
        header-class="header-nipige-class"
        size="lg"
        centered
        hide-footer
      >
        <sofficemodel>
          <template v-slot:footer-button="data">
            <b-button
              class="btn btn-block mt-3"
              btn-color="primary"
              @click="OfficeToNext(data.data)"
              >Update</b-button
            >
          </template>
        </sofficemodel>
      </b-modal>
    <b-row class="px-2 mt-1">
      <b-col md="3">
        <p class="left-text">Office Address :</p>
      </b-col>
      <b-col md="9">
        <p class="right-text">
          {{ partnerAddress }}
        </p>
      </b-col>
    </b-row>
    <b-row class="m-2 line-bottom"></b-row>
    <b-row class="px-2">
      <b-col>
        <b-row>
          <b-col md="6">
            <p class="left-text">Phone # :</p>
          </b-col>
          <b-col md="6">
            <p class="right-text">
              {{
                partnerData &&
                partnerData.authentication &&
                partnerData.authentication.phone
              }}
            </p>
          </b-col>
        </b-row>
      </b-col>
      <b-col>
        <b-row>
          <b-col class="line" md="5">
            <p class="left-text">Email Id :</p>
          </b-col>
          <b-col md="7">
            <p class="right-text">
              {{
                partnerData &&
                partnerData.authentication &&
                partnerData.authentication.email
              }}
            </p>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import sofficemodel from "@/components/Partner/PartnerEdit/OfficeStepper";
import { mapGetters } from "vuex";
export default {
  name: "officeView",
  props: ["partnerData"],
  components: {
    sofficemodel,
  },
  computed: {
    ...mapGetters({
      partnerAllData: "partner/GetPartnerData",
      getCategoryList: "catalog/GetCategoryList",
    }),
    partnerAddress() {
      if (this.partnerData.office.address) {
        const { street1, street2, city, state, zip } = this.partnerData.office.address;
        return `${street1 ? street1 + ', ' : ''}${street2 ? street2 + ', ' : ''}${city}, ${state}-${zip}`;
      }
    },
  },
  methods: {
    async OfficeToNext(data) {
      let payload = {
        id: this.partnerAllData._id,
        data: {
          office: data,
          category: data.category.value,
        },
      };
      await this.$store
        .dispatch("partner/updatePartner", payload)
        .then((result) => {
          this.$swal({
            title: "Success",
            text: "Partner Edited successfully!",
            type: "success",
          });
          this.$emit("reload-partner", this.partnerAllData._id);
          this.$root.$emit("bv::hide::modal", "officeEdit", "#btnShow");
        })
        .catch((error) => {
          this.$swal({
            title: "Error",
            text: "Could not Edited partner",
            type: "error",
          });
        });
    },
  },
};
</script>

<style scoped>
.left-text {
  margin-bottom: 0px;
  font-size: 16px;
  font-weight: 500;
  color: #58585b;
}
.right-text {
  margin-bottom: 0px;
  font-size: 16px;
  font-weight: 600;
  color: #000000;
}
[btn-color="primary1"] {
  outline: none !important;
  border-radius: 50%;
  height: 39px;
  width: 39px;
  margin-left: 10px;
  padding: 0;
}
[btn-special="primary1"] {
  border-radius: 50%;
}
.line {
  border-left: 1px dashed #c2c2c2;
}
.line-bottom {
  border-bottom: 1px dashed #c2c2c2;
}
@media (max-width: 576px) {
  .edit_button {
    margin-left: auto;
    display: block;
  }

  .b-col {
    display: flex;
    align-items: center;
  }
}
</style>
